import 'intersection-observer';
import React, { Component } from 'react';
import { tsv } from 'd3-fetch';
import { tween } from 'shifty';

import Visualization from '../Visualization/Visualization';
import StyledApp from './StyledApp';
import Slider from '../Slider/Slider';
import ArrowBar from '../ArrowBar/ArrowBar';
import ProgressBar from '../ProgressBar/ProgressBar';

class App extends Component {

	state = {
		currentStep: 1,
		previousStep: 1,
		numberOfSteps: 16,
		scrollBoxHeight: 0,
		orientation: 'vertical',
		showScatter: 'scatter1',
		showBarchart: null,
		highlights: [],
		dataUrl: 'https://etalage.argumentenfabriek.nl/cpb/koopkracht/data/',
		data: {}
	}

	componentDidMount() {

		window.addEventListener('resize', this.updateDimensions);
		window.addEventListener('keydown', this.onKeyDown);

		this.updateDimensions();
		this.initObserver();
		this.getData();
	}

	async getData() {
		const { data } = this.state;
		const isDevelopment = process.env.NODE_ENV === 'development'
			|| window.location.hostname === 'argumentenfabriek.gitlab.io';
		const dataUrl = isDevelopment ? process.env.PUBLIC_URL + '/data/' : this.state.dataUrl;

		const dataGroepen = await tsv(dataUrl + 'groepen.tsv');
		const dataScatter = await tsv(dataUrl + 'puntenwolk.tsv');
		const dataAsObject = {};

		dataGroepen.map(row => { dataAsObject[row.groep] = row; row.name = row.groep; return row;});

		data.scatter = await dataScatter;
		data.groepen = dataGroepen;
		data.asObject = dataAsObject;

		this.setState({ data });
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateDimensions);
		window.removeEventListener('keydown', this.onKeyDown);
	}

	updateDimensions = () => {
		const pageWidth = window.innerWidth;
		const orientation = pageWidth <= 576 ? 'horizontal' : 'vertical';
		const container = document.querySelector('#af-scroll-text');
		const scrollBoxHeight = container.getBoundingClientRect().height;
		this.setState({ orientation, scrollBoxHeight });
	}

	initObserver = () => {

		let thresholdProgress;

		function setThreshold() {
			const count = 100;
			thresholdProgress = [];
			const ratio = 1 / count;
			for (let i = 0; i < count; i++) {
				thresholdProgress.push(i * ratio);
			}
		}

		function selectionToArray(selection) {
			const len = selection.length;
			const result = [];
			for (let i = 0; i < len; i += 1) {
				result.push(selection[i]);
			}
			return result;
		}

		function selectAll(selector, parent = document) {
			return selectionToArray(parent.querySelectorAll(selector));
		}

		const callback = (entries, observer) => {
			const container = document.querySelector('#af-scroll-text');
			const scrollBoxTop = container.getBoundingClientRect().top;
			const scrollBoxHeight = container.getBoundingClientRect().height;

			entries.forEach(entry => {
				let safetyMargin = -40;
				const currentStepID = +this.state.currentStep;
				const thisStepID = +entry.target.dataset.step;
				let stepTop =  entry.boundingClientRect.top - scrollBoxTop;
				const stepHeight = entry.boundingClientRect.height;
				const boundary = 0.5 * scrollBoxHeight;
				if (stepHeight > scrollBoxHeight) safetyMargin =  - (stepHeight - scrollBoxHeight - safetyMargin);
				if (stepTop > safetyMargin && stepTop < boundary && thisStepID !== currentStepID){
					this.setState({ currentStep: thisStepID, previousStep: currentStepID })
					//console.log(thisStepID + ' enters the zone!');
				}
			});
		};

		setThreshold();

		const options = {
			root: document.querySelector('#af-scroll-text'),
			rootMargin: '0px',
			threshold: thresholdProgress
		}

		const observer = new IntersectionObserver(callback, options);

		const targets = selectAll('.af-step');
		targets.forEach(target => observer.observe(target))

	}

	onKeyDown = (ev) => {
		const keyDown = ev.key ?  ev.key : ev.keyCode;
		const { currentStep } = this.state;

		if (keyDown === 'ArrowRight' || keyDown === 'Right' || keyDown === 'ArrowDown' ||  keyDown === 'Down' || keyDown === 39 || keyDown === 40) {
			ev.preventDefault();
			this.slide('up', +currentStep+1)
		}

		if (keyDown === 'ArrowLeft' || keyDown === 'Left' || keyDown === 'ArrowUp' || keyDown === 'Up' || keyDown === 37 || keyDown === 38) {
			ev.preventDefault();
			this.slide('down', +currentStep-1)
		}
	}

	slide = (direction, nextStep) => {

		const container = document.querySelector('#af-scroll-text');
		const easing = 'easeInOutCubic';
		const stepElement = document.querySelector('#af-step-'+nextStep);
		let delta;

		if (stepElement && direction === 'up') {
				delta = stepElement.getBoundingClientRect().top - container.getBoundingClientRect().top;

				tween({
					from: { x: container.scrollTop  },
					to: { x: container.scrollTop + delta },
					duration: 500,
					easing: easing,
					step: state => container.scrollTop  = state.x
				})
				.then(
				  () => {
				  	const { currentStep } = this.state;
				  	const visUpdated = currentStep === nextStep;
				  	if (!visUpdated) this.setState({ currentStep: nextStep, previousStep: currentStep })
				  }
				);

			}

		if (stepElement  && direction === 'down') {

			const delta = container.getBoundingClientRect().top - stepElement.getBoundingClientRect().top;

				tween({
					from: { x: container.scrollTop  },
					to: { x: container.scrollTop - delta},
					duration: 500,
					easing: easing,
					step: state => container.scrollTop  = state.x
				})
				.then(
				  () => {
				  	const { currentStep } = this.state;
				  	const visUpdated = currentStep === nextStep;
				  	if (!visUpdated) this.setState({ currentStep: nextStep, previousStep: currentStep })
				  }
				);

			}

	}

	gotoStep = (direction, nextStep) => {

		const container = document.querySelector('#af-scroll-text');
		const stepElement = document.querySelector('#af-step-'+nextStep);
		let delta;

		if (stepElement && direction === 'up') {
				delta = stepElement.getBoundingClientRect().top - container.getBoundingClientRect().top;
				container.scrollTop  = container.scrollTop + delta;
			}

		if (stepElement  && direction === 'down') {
			delta = container.getBoundingClientRect().top - stepElement.getBoundingClientRect().top;
			container.scrollTop  = container.scrollTop - delta;
			}
	}

	arrowDownHandler = (evt) => {
		evt.preventDefault();
		const { currentStep } = this.state;
		const nextStep = currentStep + 1;
		this.slide('down', nextStep);
	}

	arrowUpHandler = (evt) => {
		evt.preventDefault();
		const { currentStep } = this.state;
		const nextStep = currentStep - 1;
		this.slide('up', nextStep);
	}


	changeHighlights = (evt) => {
		evt.preventDefault();
		const id = evt.target.id;
		const highlights = this.state.highlights;
		const index = highlights.indexOf(id);
		index === -1 ? highlights.push(id) : highlights.splice(index, 1);
		this.setState({ highlights})
	}

	render() {

		const { data, currentStep, previousStep, numberOfSteps, scrollBoxHeight, showScatter, showBarchart, highlights } = this.state;
		const slideHeight = 500;
		const gotoTop = (evt) => {
			evt.preventDefault();
			this.gotoStep('up', 1);
		}

		return (
			<StyledApp slideHeight={slideHeight}>
			<h1><a href="#top" onClick={gotoTop}>Koopkracht in beeld</a></h1>
				<div className='af-scroll'>
					<div className="af-scroll-debug"></div>

					<Visualization
						currentStep={currentStep}
						previousStep={previousStep}
						slideHeight={slideHeight}
						data={data}
						showScatter={showScatter}
						showBarchart={showBarchart}
						highlights={highlights}
					/>

					<Slider
						currentStep={currentStep}
						scrollBoxHeight={scrollBoxHeight}
						changeHighlights={this.changeHighlights}
					/>

					<ProgressBar
						currentStep={currentStep}
						numberOfSteps={numberOfSteps}
						slide={this.slide}
					/>

					<ArrowBar
						arrowDownHandler={this.arrowDownHandler}
						arrowUpHandler={this.arrowUpHandler}
						currentStep={currentStep}
						numberOfSteps={numberOfSteps}
					/>

				</div>
			</StyledApp>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js